/**
 * Role helpers — single source of truth for what the current user may do.
 *
 * getAgentRole was previously copy-pasted into four files. Same drift risk as
 * hardcoded brand colours: when the rules change, some copies get updated and
 * some don't. Import from here instead.
 *
 * The server is the real gate (middleware/auth.js). These helpers only decide
 * what to RENDER — never rely on them for security, only for not showing
 * someone a button that will 403.
 */

// Roles that may read everything but must not mutate shared data.
// Keep in sync with READ_ONLY_ROLES in server/middleware/auth.js.
export const READ_ONLY_ROLES = ['marketing'];

export function getAgentRole() {
  try {
    return JSON.parse(localStorage.getItem('feedback_agent') || '{}').role || '';
  } catch {
    return '';
  }
}

export function getAgentName() {
  try {
    const a = JSON.parse(localStorage.getItem('feedback_agent') || '{}');
    return a.name || a.email || '';
  } catch {
    return '';
  }
}

/** True for roles that may not change shared data (cluster status, syncs, refresh). */
export function isReadOnly(role = getAgentRole()) {
  return READ_ONLY_ROLES.includes(role);
}

/** May mutate clusters and trigger pipeline actions. */
export function canWrite(role = getAgentRole()) {
  return !isReadOnly(role);
}

/** Customer PII and outbound marketing email — leadership/admin only. */
export function canExport(role = getAgentRole()) {
  return role === 'leadership' || role === 'admin';
}

/** Health/status page. */
export function canViewHealth(role = getAgentRole()) {
  return role === 'admin' || role === 'leadership';
}
